import { MutableRefObject } from "react";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import vtkSphereSource from "@kitware/vtk.js/Filters/Sources/SphereSource";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";

export const addSphere = (
  viewport: any,
  sphereActorRef: MutableRefObject<any>,
  point: [number, number, number]
) => {
  if (!sphereActorRef.current) {
    // Generate a random string for the sphere UID
    const randomUID = "sphere_" + Math.random().toString(36).substring(2, 15);

    const sphereSource = vtkSphereSource.newInstance();
    sphereSource.setCenter(point);
    sphereSource.setRadius(5);

    const sphereMapper = vtkMapper.newInstance();
    sphereMapper.setInputConnection(sphereSource.getOutputPort());

    const sphereActor = vtkActor.newInstance();
    sphereActor.setMapper(sphereMapper);
    sphereActor.getProperty().setColor(0.0, 0.0, 1.0);
    
    // Assign to the ref
    sphereActorRef.current = sphereActor;

    viewport.addActor({ actor: sphereActor, uid: randomUID });
  } else {
    sphereActorRef.current
      .getMapper()
      .getInputConnection()
      .filter.setCenter(point);
  }

  viewport.render();
};
